import { render, staticRenderFns } from "./teamhis.vue?vue&type=template&id=b136d47a&scoped=true"
import script from "./teamhis.vue?vue&type=script&lang=js"
export * from "./teamhis.vue?vue&type=script&lang=js"
import style0 from "./teamhis.vue?vue&type=style&index=0&id=b136d47a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b136d47a",
  null
  
)

export default component.exports